<div class="phone-number">
  <mat-icon class="phone-number__icon" svgIcon="phone" role="presentation" aria-hidden="true"></mat-icon>
  <hr class="phone-number__divider" />
  <a
    ignoreExternLink
    class="phone-number__link"
    href="tel:0800122500"
    aria-label="Contactez-nous au 0 800 122 500"
    (click)="tracker.emit()"
    >0&nbsp;800&nbsp;122&nbsp;500</a
  >
</div>
